import { useState, useRef } from "react";
import { View, StyleSheet } from "react-native";
import CustomModal from "../../../../common/general/CustomModal/CustomModal";
import CustomText from "../../../../common/general/CustomText/CustomText";
import CustomSpacing from "../../../../common/layout/CustomSpacing/CustomSpacing";
import CustomTextInput from "../../../../common/general/CustomTextInput/CustomTextInput";
import CustomButton from "../../../../common/general/CustomButton/CustomButton";
import Loader from "../../../../common/status/Loader/Loader";
import useResponsiveScreen from "../../../../../hooks/useResponsiveScreen";

const feedbackData = ["Invalid Resource", "Harmful/unsafe content", "Misinformation", "Irrelevant content"];

function LessonFeedbackModal({ visible, onClose, isPositive, onSubmit, errorMessage, isLoading }) {
  const { isMedium } = useResponsiveScreen();
  const [responseInput, setResponseInput] = useState("");
  const [feedback, setFeedback] = useState(feedbackData[0]);

  const handleTextChange = (text) => {
    setResponseInput(text);
  };

  const inputRef = useRef(null);

  const handleShow = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleSubmit = () => {
    onSubmit(feedback, responseInput);
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      exitFill="#BBB"
      onShow={handleShow}
      ariaLabel="Lesson feedback modal">
      <View
        style={{
          ...styles.bodyContainer,
          paddingHorizontal: isMedium ? 12 : 0,

          paddingBottom: isMedium ? 12 : 0,
        }}>
        <CustomText text="Provide additional feedback" size="l" weight="ultraBold" style={{ color: "#182230" }} />
        <CustomSpacing type="vertical" size="s" />
        <CustomText
          text="We really value your feedback—it helps us make Primer even better for you!"
          size="s"
          style={{ color: "#667085" }}
        />
        {!isPositive && (
          <>
            <CustomSpacing type="vertical" size="l" />
            <View style={styles.feedbackButtons}>
              {feedbackData.map((item) => (
                <CustomButton
                  key={item}
                  text={item}
                  styleType="primary"
                  style={[
                    feedback !== item && { backgroundColor: "#F9FAFB" },
                    styles.feedbackTypeButton,
                    {
                      paddingHorizontal: 8,
                      paddingVertical: 4,
                    },
                  ]}
                  textStyle={[{ color: feedback === item ? "#FFF" : "#667085" }, styles.feedbackTypeText]}
                  onPress={() => setFeedback(item)}
                />
              ))}
            </View>
          </>
        )}
        <CustomSpacing type="vertical" size="s" />
        <View aria-live={errorMessage ? "polite" : "none"}>
          {errorMessage ? (
            <>
              <CustomText role="alert" text={errorMessage} size="xs" style={styles.failedText} />
              <CustomSpacing type="vertical" size="s" />
            </>
          ) : (
            <CustomSpacing type="vertical" size="m" />
          )}
        </View>
        <View aria-live="polite">
          {isLoading ? (
            <View style={styles.loadingContainer}>
              <Loader />
            </View>
          ) : (
            <CustomTextInput
              placeholder="Please explain your choice here."
              multiline
              numberOfLines={6}
              onChangeText={handleTextChange}
              value={responseInput}
              autoFocus={true}
              inputRef={inputRef}
            />
          )}
        </View>
        <CustomSpacing type="vertical" size="m" />
        <CustomButton
          text={isLoading ? "Sending..." : "Submit"}
          styleType="primary"
          bold
          onPress={handleSubmit}
          disabled={isLoading}
          aria-label={isLoading ? "Sending..." : "Submit"}
        />
      </View>
    </CustomModal>
  );
}

const styles = StyleSheet.create({
  bodyContainer: {
    flex: 1,
    paddingTop: 0,
  },
  loadingContainer: {
    alignItems: "center",
    minHeight: 118,
  },
  failedText: {
    color: "red",
  },
  feedbackTypeButton: {
    borderRadius: 100,
    boxShadow: "none",
  },
  feedbackButtons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: 12,
  },
  feedbackTypeText: {
    fontSize: 12,
    fontFamily: "Inter",
    fontWeight: 600,
    padding: 0,
  },
});

export default LessonFeedbackModal;
